/**
 * @module public/js/admin/tenantSettingsGamification.js
 * @summary Normalizes the tenant-wide gamification feature setting.
 */

/**
 * Determine whether gamification is explicitly enabled for a tenant.
 *
 * Missing and non-boolean values default to disabled so existing tenants do
 * not opt in automatically.
 *
 * @param {Record<string, unknown>} [generalConfig={}] - Tenant general config.
 * @returns {boolean} True only when gamification is explicitly enabled.
 */
export function isGamificationEnabled(generalConfig = {}) {
  return generalConfig?.gamificationEnabled === true;
}

/**
 * Build the Firestore merge payload for the gamification setting.
 *
 * @param {unknown} enabled - Candidate toggle value.
 * @returns {{gamificationEnabled: boolean}} Normalized config update.
 */
export function buildGamificationConfigUpdate(enabled) {
  return {
    gamificationEnabled: enabled === true,
  };
}
